var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"certificado"}},[_c('CpBanner'),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.prepareToPrint}},[_vm._v("Imprimir certificado")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }